import React, { useState } from 'react';
import { authFetch } from '../../utils/authFetch';

const UserMerge = () => {
  const [primaryEmail, setPrimaryEmail] = useState('');
  const [secondaryEmail, setSecondaryEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const runMerge = async (dryRun) => {
    setLoading(true);
    setError('');
    setResult(null);
    try {
      const res = await authFetch('/api/admin/users/merge', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ primaryEmail, secondaryEmail, dryRun }),
      });
      const data = await res.json();
      if (!res.ok || data.ok === false) {
        setResult(data);
        throw new Error(data.error || 'merge_failed');
      }
      setResult(data);
    } catch (e) {
      setError(e.message || 'Merge failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 960, margin: '64px auto', padding: '0 20px' }}>
      <h1 style={{ color: '#0f084b' }}>Merge User Accounts</h1>
      <p style={{ color: '#0f084b', opacity: 0.75 }}>
        Use this support-only tool to fold a secondary account into a primary account. Always run a dry run first.
      </p>

      <div style={{ display: 'grid', gap: 16, marginTop: 24 }}>
        <label>
          Primary email (kept)
          <input
            type="email"
            value={primaryEmail}
            onChange={(e) => setPrimaryEmail(e.target.value)}
            style={{ display: 'block', width: '100%', padding: 12, marginTop: 6 }}
          />
        </label>
        <label>
          Secondary email (merged)
          <input
            type="email"
            value={secondaryEmail}
            onChange={(e) => setSecondaryEmail(e.target.value)}
            style={{ display: 'block', width: '100%', padding: 12, marginTop: 6 }}
          />
        </label>
        <div style={{ display: 'flex', gap: 12 }}>
          <button className="button-stroke" type="button" disabled={loading} onClick={() => runMerge(true)}>
            {loading ? 'Working...' : 'Dry Run'}
          </button>
          <button className="button" type="button" disabled={loading || !result || result.dryRun !== true || result.conflicts?.length} onClick={() => runMerge(false)}>
            Execute Merge
          </button>
        </div>
      </div>

      {error && <div style={{ color: '#dc1d08', marginTop: 16 }}>{error}</div>}
      {result && (
        <pre style={{ background: '#f6f7f9', padding: 16, borderRadius: 12, marginTop: 24, overflow: 'auto' }}>
          {JSON.stringify(result, null, 2)}
        </pre>
      )}
    </div>
  );
};

export default UserMerge;
